/* UploadForm Component */
import type { ReactElement } from "react";
import React from "react";
import { Button, FileInput } from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";

const FORM_PLACEHOLDER = "Click to upload a CSV File";

const UploadForm: React.FC<{
  csv: File | null;
  setCsv: (file: File | null) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children?: ReactElement;
}> = ({ csv, setCsv, onSubmit, children }) => (
  <form onSubmit={onSubmit}>
    <FileInput
      placeholder={FORM_PLACEHOLDER}
      accept=".csv"
      leftSection={<IconUpload />}
      value={csv}
      onChange={setCsv}
      style={{ marginTop: 10 }}
    />
    {children}
    <div className="bulk-buttons">
      <Button
        type="submit"
        mt="sm"
        disabled={!csv}
        style={{ marginLeft: "auto" }}
      >
        Bulk Upload
      </Button>
    </div>
  </form>
);

export default UploadForm;
